import appConfig from 'app-config';
import _ from 'lodash';
import FileSaver from 'file-saver';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

const { DocumentRetrievalEndPointURI, httpSettings } = appConfig;

const policyCenterRetrievalURI = `${httpSettings.serviceBaseURLs.pc}${DocumentRetrievalEndPointURI.pcPreview}`;
const documentNotFoundURL = `${window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/PolicyDocumentError`;

function encodeBasicAuth(login, password) {
    return window.btoa(`${login}:${password}`);
}

// Searches for the authentication header
function findAuthHeader(settings) {
    const authOptions = settings.auth;
    if (authOptions === null) {
        return null;
    }
    if (typeof authOptions === 'string') {
        return authOptions;
    }

    switch (authOptions.kind) {
        case 'basic' :
            return `Basic ${encodeBasicAuth(authOptions.username, authOptions.password)}`;
        default :
            return null;
    }
}

const viewForm = (downloadErrorCallback, form, sessionID, foreignId, quotePublicId, instrumentId, policyNumbers, authHeader) => {
    const policyNumbersParam = _.isEmpty(policyNumbers) ? '' : policyNumbers.join();
    const instrumentIdParam = _.isEmpty(instrumentId) ? '' : instrumentId;
    const appendToUrl = `${foreignId}?form=${form.formNumber}&quotePublicId=${quotePublicId}&token=${sessionID}&portalRoute=${documentNotFoundURL}&instrumentId=${instrumentIdParam}&policyNumbers=${policyNumbersParam}`;

    return GatewayDocumentService.downloadDocumentPreview(appendToUrl, authHeader, downloadErrorCallback);
}

const viewSubmissionForm = (downloadErrorCallback, form, submissionVM, authHeader) => {
    const sessionID = submissionVM.sessionUUID.value;
    const foreignId = submissionVM.quoteID.value;
    const quotePublicId = submissionVM.bindData.chosenQuote.value;
    return viewForm(downloadErrorCallback, form, sessionID, foreignId, quotePublicId, null, null, authHeader);
};

const getFormData = (form, submissionVM) => {
    const sessionID = submissionVM.sessionUUID.value;
    const foreignId = submissionVM.quoteID.value;
    const quotePublicId = submissionVM.bindData.chosenQuote.value;
    const policyNumbersParam = '';
    const instrumentIdParam = '';
    const url = `${policyCenterRetrievalURI}/${foreignId}?form=${form.formNumber}&quotePublicId=${quotePublicId}&token=${sessionID}&portalRoute=${documentNotFoundURL}&instrumentId=${instrumentIdParam}&policyNumbers=${policyNumbersParam}`;
    const baseHeaders = {
        Authorization: findAuthHeader(httpSettings)
    };

    const jwtForDev = localStorage.getItem('jwtForDev');
    if (jwtForDev) {
        baseHeaders.jwtForDev = `Bearer ${jwtForDev}`;
    }

    const headers = _.clone(baseHeaders);
    return fetch({
        method: 'GET',
        url: url,
        responseType: 'arraybuffer',
        headers,
        timeout: httpSettings.timeout
    });
};

const getFormDataForPayment = (form, submissionVM,authHeader) => {
    const sessionID = submissionVM.sessionUUID.value;
    const foreignId = submissionVM.quoteID.value;
    const quotePublicId = submissionVM.bindData.chosenQuote.value;
    const policyNumbersParam = '';
    const instrumentIdParam = '';
    const displayErrorModal = null;
    //const url = `${policyCenterRetrievalURI}/${foreignId}?form=${form.formNumber}&quotePublicId=${quotePublicId}&token=${sessionID}&portalRoute=${documentNotFoundURL}&instrumentId=${instrumentIdParam}&policyNumbers=${policyNumbersParam}`;
    const appendToUrl = `${foreignId}?form=${form.formNumber}&quotePublicId=${quotePublicId}&token=${sessionID}&portalRoute=${documentNotFoundURL}&instrumentId=${instrumentIdParam}&policyNumbers=${policyNumbersParam}`;
    return GatewayDocumentService.downloadDocumentPreview(appendToUrl, authHeader, displayErrorModal);

};

const saveFormAsFile = (form, response, responseHeaders) => {
    const file = new Blob([response], { type: responseHeaders('Content-Type') });
    FileSaver.saveAs(file, form.formDescription.value);
};

export default {
    viewSubmissionForm: viewSubmissionForm,
    viewForm: viewForm,
    getFormData: getFormData,
    saveFormAsFile: saveFormAsFile,
    getFormDataForPayment: getFormDataForPayment
};